<template>
  <b-row class="mt-5">
    <b-col md="9">
      <b-form-group label="لیست کلمات کلیدی" class="w-100" label-for="table">
        <b-table id="table" striped hover :fields="fields" :items="TableItems">
          <template #cell(name)="data">
            {{ data.item.name }}
          </template>
          <template #cell(action)="data">
            <span class="h5" @click="deleteKeyWord(data.item)" v-b-tooltip.hover title="حذف">
              <b-icon icon="trash"></b-icon>
            </span>
          </template>
        </b-table>
      </b-form-group>
    </b-col>
    <b-col md="3" class="mt-4">
      <form @submit.prevent="addToKeyWordTable(word)">
        <b-form-input placeholder=" کلمه کلیدی" debounce="500" v-model="word" class="mb-1"></b-form-input>
      </form>
      <p class="text-danger d-none" id="error">این کلمه قبلا وارد شده</p>
      <b-button pill variant="purple" @click="addToKeyWordTable(word)">اضافه به لیست
      </b-button>
    </b-col>
  </b-row>
</template>
<script>
export default {
  name: "FeaturesManager",
  props: ["TableItems", "keyWords"],
  data() {
    return {
      fields: [
        { key: "name", label: "کلمه کلیدی" },
        { key: "action", label: "" },
      ],
      keywords: this.keyWords,
      word: "",
    };
  },
  methods: {
    addToKeyWordTable(keyWord) {
      let flag = false;
      this.keyWords.forEach((item) => {
        if (item == keyWord) {
          flag = true;
          document.getElementById("error").classList.remove("d-none");
          document.getElementById("error").classList.add("d-block");
        }
      });
      if (keyWord !== "" && flag == false) {
        let f = { name: keyWord };
        this.keyWords.push(keyWord);
        this.TableItems.push(f);
        document.getElementById("error").classList.remove("d-block");
        document.getElementById("error").classList.add("d-none");
        this.word = "";
      }
    },

    deleteKeyWord(item) {
      let index;
      for (let i in this.keyWords) {
        if (this.keyWords[i] === item.name) {
          index = i;
        }
      }
      this.keyWords.splice(index, 1);
      this.TableItems.splice(index, 1);
    },


  },
};
</script>